import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg = this.state.error?.message || "Errore sconosciuto";
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center px-6" data-testid="error-boundary">
        <div className="max-w-lg w-full bg-white border border-ink/10 p-10 rounded-sm">
          <div className="text-[11px] tracking-[0.3em] uppercase text-rose-700">Errore</div>
          <h1 className="mt-3 font-display text-3xl font-light text-ink">Qualcosa è andato storto.</h1>
          <p className="mt-4 text-sm text-slate1 leading-relaxed">
            Si è verificato un errore imprevisto. Puoi provare a ricaricare la pagina o tornare alla home.
          </p>
          <pre className="mt-5 p-4 bg-cream2 text-xs text-slate1 rounded-sm overflow-auto max-h-32 whitespace-pre-wrap">{msg}</pre>
          <div className="mt-6 flex gap-3">
            <button
              onClick={() => { this.reset(); window.location.href = "/"; }}
              className="bg-ink text-cream px-5 py-2.5 text-[11px] tracking-[0.2em] uppercase rounded-sm hover-lift"
              data-testid="error-home"
            >
              Torna alla home
            </button>
            <button
              onClick={() => window.location.reload()}
              className="border border-ink/20 text-ink px-5 py-2.5 text-[11px] tracking-[0.2em] uppercase rounded-sm hover:bg-ink hover:text-cream transition-colors"
              data-testid="error-reload"
            >
              Ricarica
            </button>
          </div>
        </div>
      </div>
    );
  }
}
